export class EventPageAdding {
    facebookPageUrlOrName: string;
    displayTitle?: string;
    tags?: string;
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.account/event.add.page.ts